export const Panel = ({ title, sub, action, children, testId, className = "" }) => (
  <section data-testid={testId} className={`rounded-2xl border border-ink-600 bg-ink-800 p-5 sm:p-6 ${className}`}>
    {(title || action) && (
      <div className="mb-4 flex flex-wrap items-start justify-between gap-3">
        <div>
          {title && <h2 className="font-display text-base font-semibold text-slate-100 md:text-lg">{title}</h2>}
          {sub && <p className="mt-1 text-sm text-slate-500">{sub}</p>}
        </div>
        {action}
      </div>
    )}
    {children}
  </section>
);

export const Empty = ({ children, testId }) => (
  <p data-testid={testId} className="rounded-xl border border-dashed border-ink-600 px-4 py-8 text-center text-sm text-slate-500">
    {children}
  </p>
);

export const Chip = ({ children, className = "", testId }) => (
  <span data-testid={testId}
    className={`inline-flex items-center rounded-full border px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-widest ${className || "border-ink-600 bg-ink-700 text-slate-400"}`}>
    {children}
  </span>
);

export const Tag = ({ children }) => (
  <p className="font-mono text-[10px] uppercase tracking-widest text-slate-500">{children}</p>
);

export const Err = ({ children, testId }) =>
  children ? (
    <p data-testid={testId} className="rounded-xl border border-red-500/40 bg-red-500/10 p-3 text-sm text-red-200">
      {children}
    </p>
  ) : null;

export const Ok = ({ children, testId }) =>
  children ? (
    <p data-testid={testId} className="rounded-xl border border-emerald-500/40 bg-emerald-500/10 p-3 text-sm text-emerald-200">
      {children}
    </p>
  ) : null;
